import InformationModal from 'components/elements/modal/InformationModal'
import { WebSocketUtilsContext } from 'contexts/WebSocketUtilsContext'
import React, { useContext } from 'react'

const WebSocketDisconnectModal: React.FC = () => {
  const [webSocketUtils] = useContext(WebSocketUtilsContext)
  return (
    <InformationModal
      on={webSocketUtils.forceDisconnect}
      content={
        '別のタブが開かれたため、\nこちらのタブはご利用いただけなくなっています。\n\n最後に開いたタブをご覧いただくか、再度SMSに記載されたURLにアクセスしてください。'
      }
      top={'90px'}
      greyBack
      modalFill
      textCenter
    />
  )
}

export default WebSocketDisconnectModal
